var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSchoolAverageIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.625 8.75H3.45C3.02996 8.75 2.81994 8.75 2.65951 8.83175C2.51839 8.90365 2.40365 9.01839 2.33175 9.15951C2.25 9.31994 2.25 9.52996 2.25 9.95V16.25M12.375 8.75H14.55C14.97 8.75 15.1801 8.75 15.3405 8.83175C15.4816 8.90365 15.5964 9.01839 15.6683 9.15951C15.75 9.31994 15.75 9.52996 15.75 9.95V16.25M12.375 16.25V5.15C12.375 4.30992 12.375 3.88988 12.2115 3.56901C12.0677 3.28677 11.8382 3.0573 11.556 2.91349C11.2351 2.75 10.8151 2.75 9.975 2.75H8.025C7.18492 2.75 6.76488 2.75 6.44402 2.91349C6.16177 3.0573 5.9323 3.28677 5.78849 3.56901C5.625 3.88988 5.625 4.30992 5.625 5.15V16.25M16.5 16.25H1.5M8.25 5.75H9.75M8.25 8.75H9.75M8.25 11.75H9.75",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchoolAverageIcon);
export default __webpack_public_path__ + "static/media/SchoolAverageIcon.2903a6533bcc2c4dcceac9028bc585be.svg";
export { ForwardRef as ReactComponent };